import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { Form } from 'react-bootstrap';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useIntl } from 'react-intl';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const ReferralEmail = ({ values, errors, updateSchema }: Props) => {
  const REFERRAL_UBISOFT_EMPLOYEE_ID = 9;
  const intl = useIntl();

  const [referralEmail, setReferralEmail] = useState<string | undefined>(
    values.referralEmail
  );

  useEffect(() => {
    const referralEmailSchema = GetShema();
    updateSchema(referralEmailSchema);
    values.referralEmail = DisplayReferralEmailQuestion(values.referralIds)
      ? referralEmail!
      : undefined;

    if (!DisplayReferralEmailQuestion(values.referralIds)) {
      setReferralEmail(undefined);
    }
  }, [referralEmail, values.referralIds]);

  const DisplayReferralEmailQuestion = (element: number[]) => {
    return element?.includes(REFERRAL_UBISOFT_EMPLOYEE_ID);
  };

  const GetShema = () => {
    return {
      referralEmail: Yup.string()
        .trim()
        .email(intl.formatMessage({ ...siteMessages.FIELD_INVALID_EMAIL }))
    };
  };

  return values.referralIds?.includes(REFERRAL_UBISOFT_EMPLOYEE_ID) ? (
    <Form.Group controlId="referralEmail">
      <Form.Label className="input fw-bold">
        {intl.formatMessage({ ...messages.referralEmail })}
      </Form.Label>
      <Form.Control
        name="referralEmail"
        type="email"
        placeholder={intl.formatMessage({
          ...messages.referralEmailPlaceholder
        })}
        defaultValue={values.referralEmail}
        onChange={(event: any) => setReferralEmail(event.target.value)}
        isInvalid={errors.referralEmail}
      />
      {errors.referralEmail && (
        <Form.Control.Feedback type="invalid">
          <FiAlertTriangle className="mb-1 me-1" />
          {errors.referralEmail}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  ) : (
    <></>
  );
};

export default ReferralEmail;
